import { EduComponent } from "../utils/eduComponent"
import { UserService } from "../services/user.service"
import { Router } from "@angular/router"

export class StudentLogin extends EduComponent {
    public username: string = ""
    public secretQuestion: string = "Secret Question N/A"
    public isLoginValid: string = "Not evaluated"
    public isLoginInitiated: boolean = false
    public isLoginValidationInitiated: boolean = false
    private userService: UserService
    private router: Router
    private loginStep: number = 1

    constructor(userService: UserService, router: Router) {
        super()
        this.userService = userService
        this.router = router
    }

    // INFO: First step of user (student) login, the username is requested
    public initiateLogin(username: string): void {
        this.isLoginInitiated = true
        this.username = username

        this.clearSubs()
        this.addSub(
            this.userService.postStudentUsername(username).subscribe((response: any) => {
                if (response && response.secret_question != null) {
                    this.secretQuestion = response.secret_question
                    this.loginStep = 2
                } else {
                    this.secretQuestion = null
                    this.loginStep = 1
                }
            })
        )
    }

    // INFO: Last step of user (student) login, the secret answer is requested
    public validateLogin(secretAnswer: string): void {
        this.isLoginValidationInitiated = true

        this.clearSubs()
        this.addSub(
            this.userService
                .postSecretAnswer(
                    this.username,
                    this.secretQuestion,
                    secretAnswer,
                    this.getCurrentStudentPath()
                )
                .subscribe((response: any) => {
                    if (response && response.authenticated) {
                        this.isLoginValid = "True"
                        // INFO: Extra check, the response should always have a "next_url" attribute.
                        if (response.next_url) {
                            this.router.navigate([response.next_url]).then(() => {
                                window.location.reload()
                            })
                        } else {
                            window.location.reload()
                        }
                    } else {
                        this.isLoginValid = "False"
                    }
                })
        )
    }

    public shouldDisplayUsernameInput(): boolean {
        return this.loginStep === 1
    }

    public shouldDisplayQuestionInput(): boolean {
        return this.loginStep === 2
    }

    public generateLabelFromSecretQuestion(): string {
        if (this.secretQuestion) {
            return this.secretQuestion.slice(0, -1).split(" ").splice(-2).join(" ")
        }

        return "Secret Answer"
    }

    public getSecretQuestion(): string {
        if (this.secretQuestion) {
            return this.secretQuestion
        }

        return null
    }

    public restoreInitialSecretQuestionValue(): void {
        this.secretQuestion = "Secret Question N/A"
    }

    public getLoginValidity(): string {
        return this.isLoginValid
    }

    public restoreInitialLoginEvaluationValue(): void {
        this.isLoginValid = "Not evaluated"
    }

    // INFO: Get the current path for a student account and set his right homepage if he logs from "/".
    public getCurrentStudentPath(): string {
        if (window.location.pathname !== "/") {
            return window.location.pathname
        }

        return "/student/"
    }
}
